import { registerApplication, start } from "single-spa";

registerApplication<{}>({
  name: "@einstein/payment-header",
  app: () => System.import("@einstein/payment-header"),
  activeWhen: ["/app-payment"],
});

registerApplication<{}>({
  name: "@va/payment",
  app: () => System.import("@va/payment"),
  activeWhen: ["/app-payment"],
});

registerApplication<{}>({
  name: "@einstein/predicta",
  app: () => System.import("@einstein/predicta"),
  activeWhen: (location) => {
    if (location.pathname !== "/schedule-dashboard") {
      return true;
    }
    return false;
  },
});

registerApplication<{}>({
  name: "@einstein/predicta-schedule-dashboard",
  app: () => System.import("@einstein/predicta-schedule-dashboard"),
  activeWhen: ["/schedule-dashboard"],
});

start({
  urlRerouteOnly: true,
});
